<!-- Take a color key and display a small circle with the color -->
<script>
  import { colors } from '@lib/utils/colors'
  import { cn } from '@lib/utils'

  let { color, size = "sm", class: className } = $props()

  let colorObject = $derived(colors[color])

  let sizeClasses = {
    xs: "w-2 h-2",
    sm: "w-3 h-3",
    md: "w-4 h-4",
    lg: "w-5 h-5",
    xl: "w-6 h-6",
  }

  let baseClass = "rounded-full"
  let colorClass = $derived(colorObject?.base)
  let sizeClass = $derived(sizeClasses[size])

  let containerClass = $derived(cn(baseClass, colorClass, sizeClass, className))
</script>

<div class={containerClass}></div>